export const PROVIDER_WEBHOOK_EVENTS = [
  'account.created',
  'user.login',
  'subscription.purchased',
  'invoice.created',
  'subscription.upgraded',
  'subscription.downgraded',
  'subscription.cancelled',
  'team_member.added',
] as const;

export type ProviderWebhookEvent = (typeof PROVIDER_WEBHOOK_EVENTS)[number];

export const PROVIDER_WEBHOOK_DELIVERY_STATUSES = [
  'pending',
  'processing',
  'succeeded',
  'failed',
] as const;

export type ProviderWebhookDeliveryStatus = (typeof PROVIDER_WEBHOOK_DELIVERY_STATUSES)[number];

export interface ProviderWebhookEndpoint {
  id: string;
  name: string;
  url: string;
  hasSecret: boolean;
  hasCustomHeaders: boolean;
  customHeaderKeys: string[];
  subscribedEvents: ProviderWebhookEvent[];
  timeout: number;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertProviderWebhookInput {
  name: string;
  url: string;
  secret?: string;
  headers?: Record<string, string>;
  subscribedEvents: ProviderWebhookEvent[];
  timeout: number;
  enabled: boolean;
}

export interface ProviderWebhookDelivery {
  id: string;
  endpointId: string;
  eventName: string;
  status: ProviderWebhookDeliveryStatus;
  attempt: number;
  responseStatus: number | null;
  responseBody: string | null;
  errorMessage: string | null;
  payload: Record<string, unknown> | null;
  dispatchedAt: string | null;
  deliveredAt: string | null;
  nextRetryAt: string | null;
  createdAt: string;
  updatedAt: string;
}
